import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LegalDocument } from '@pxtra-client-lib-legacy/gen';
import { AgreementDialog } from '../../lib/components';
import { useStore } from '../../hooks/useStore';

export const AcceptAgreements = () => {
  const [showAgreementDialog, setShowAgreementDialog] = useState(false);
  const [currentDialogIndex, setCurrentDialogIndex] = useState(0);
  const [unacceptedAgreements, setUnacceptedAgreements] = useState<LegalDocument[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    const postLogin = async () => {
      const fetchedAgreements = await authenticationStore.fetchAgreements(false);
      setUnacceptedAgreements(fetchedAgreements);
      if (fetchedAgreements.length > 0) {
        setShowAgreementDialog(true);
      }
    };
    postLogin();
  }, []);

  const { authenticationStore } = useStore();

  const handleCloseAndShowNextDialog = () => {
    setCurrentDialogIndex(currentDialogIndex + 1);
    setShowAgreementDialog(false);
  };

  useEffect(() => {
    if (authenticationStore.isLoggedIn) {
      if (!showAgreementDialog && currentDialogIndex < unacceptedAgreements.length) {
        setShowAgreementDialog(true);
      } else if (!showAgreementDialog && currentDialogIndex === unacceptedAgreements.length) {
        setUnacceptedAgreements([]);
      }
    }
  }, [showAgreementDialog]);

  return (
    <div>
      {unacceptedAgreements.map(
        (agreement, index) =>
          index === currentDialogIndex && (
            <AgreementDialog
              key={agreement.id}
              open={showAgreementDialog}
              title={t('agreements:heading1') + agreement.title + t('agreements:heading2')}
              contentText={t('agreements:scrollHint', { title: agreement.title })}
              contentHtml={agreement.content}
              onConfirm={() => {
                authenticationStore.submitAgreement(agreement.id);
                handleCloseAndShowNextDialog();
              }}
              confirmButtonText={t('common:CONFIRM')}
              checkboxText={t('agreements:agreement', { title: agreement.title })}
            />
          )
      )}
    </div>
  );
};

export default observer(AcceptAgreements);
